import { render, staticRenderFns } from "./CompensatoryLeavesListDeclined.vue?vue&type=template&id=5b78c4a6"
import script from "./CompensatoryLeavesListDeclined.vue?vue&type=script&lang=js"
export * from "./CompensatoryLeavesListDeclined.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports